module.exports = __webpack_public_path__ + "static/gary-anderson-9a413728121738760bade7f5c20563a3.png";